import { Package } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import { SimilarProductRow } from 'src/features/novelties/components/SimilarProductRow';
import type { SimilarityData } from 'src/services/api/getNoveltiesBestCandidates';

type SimilarProductsTableProps = {
  similarities: SimilarityData[];
};

export function SimilarProductsTable({
  similarities,
}: SimilarProductsTableProps): ReactElement {
  const { t } = useTranslation('novelties');

  if (similarities.length === 0) {
    return (
      <div className='flex items-center justify-center py-8 text-layout-foreground-secondary text-sm'>
        {t('No similar products found')}
      </div>
    );
  }

  return (
    <div className='space-y-3'>
      <div className='flex items-center gap-2 font-medium text-sm'>
        <Package className='size-4 text-primary-default' />
        {t('Similar Products')}
      </div>
      <div className='overflow-hidden rounded-lg border border-border-default bg-card'>
        <Table>
          <TableHeader>
            <TableRow className='h-10 bg-layout-hover'>
              <TableHead className='w-12 font-semibold text-xs'></TableHead>
              <TableHead className='font-semibold text-xs'>
                {t('SKU')}
              </TableHead>
              <TableHead className='font-semibold text-xs'>
                {t('Title')}
              </TableHead>
              <TableHead className='text-center font-semibold text-xs'>
                {t('Similarity')}
              </TableHead>
              <TableHead className='text-center font-semibold text-xs'>
                {t('Avg Forecast')}
              </TableHead>
              <TableHead className='text-right font-semibold text-xs'>
                {t('Purchase Price')}
              </TableHead>
              <TableHead className='text-right font-semibold text-xs'>
                {t('Selling Price')}
              </TableHead>
              <TableHead className='text-center font-semibold text-xs'>
                {t('Attributes')}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {similarities.map((similarity) => (
              <SimilarProductRow key={similarity.sku} similarity={similarity} />
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
